module.exports = __webpack_public_path__ + "static/shift-logo-74029cb910c3295c65456b1fb27f1306.png";